// extracted by mini-css-extract-plugin
export default {"searchResultCategories":"SearchResults_searchResultCategories__fY-FC","room":"SearchResults_room__FDNFM"};